import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { CommonConnectionModel, ElasticsearchConnectionSchema, MongoConnectionScheme, RdbmsConnectionSchema } from '../../domain/connection/ConnectionDomains';

export type ConnectionActions =
  | 'CHANGE_CONNECTION'
  | 'CHANGE_CONNECTION_IS_UPDATE'
  | 'CLEAR_CONNECTION'
  | 'CHANGE_CONNECTION_SCHEMA'
  | 'CHANGE_CONNECTION_DIRTY';

export const changeConnection = (payload: CommonConnectionModel | null) =>
  ({
    type: 'CHANGE_CONNECTION',
    payload,
  }) as ReduxBaseAction<CommonConnectionModel, ConnectionActions>;

export const changeConnectionSchema = (payload: RdbmsConnectionSchema | ElasticsearchConnectionSchema | MongoConnectionScheme | null) =>
  ({
    type: 'CHANGE_CONNECTION_SCHEMA',
    payload,
  }) as ReduxBaseAction<RdbmsConnectionSchema | ElasticsearchConnectionSchema | MongoConnectionScheme | null, ConnectionActions>;
export const changeConnectionIsUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_CONNECTION_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean, ConnectionActions>;

export const clearConnection = () =>
  ({
    type: 'CLEAR_CONNECTION',
    payload: void 0,
  }) as ReduxBaseAction<void, ConnectionActions>;

export const changeConnectionDirty = (payload: boolean) =>
  ({
    type: 'CHANGE_CONNECTION_DIRTY',
    payload,
  }) as ReduxBaseAction<any, ConnectionActions>;
